import React from "react";
//#region types
import { InvoiceFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { HTMLConstants, InvoiceConstants } from "utils/constants";
import { InvoiceTemplatePreviewProps } from "models/propTypes/invoicePropTypes";
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
import { AxiosResponse } from "axios";
//#endregion
//#region components
import { FileViewerContainer } from "components/common";
import { Portal } from "@mui/material";
import { useInvoiceService } from "serviceHooks";
import { useDebouncedCallback } from "use-debounce";
//#endregion

const InvoiceTemplatePreview: React.FC<InvoiceTemplatePreviewProps> = (props) => {
  const invoiceService = useInvoiceService();

  const {
    values,
    invoicePut,
    invoiceId,
    fromRecurring,
    recurringInvoiceVersion,
    recurringId,
    status,
    isReminder,
    serialNumber,
    ocr,
    version,
  } = props;

  const invoiceTemplateMount = document.getElementById(HTMLConstants.EntityPreviewLayoutLowerLeftPortalId);

  const [fileMeta, setFileMeta] = React.useState<ImageMeta[]>();

  const loadInvoiceTemplate = useDebouncedCallback((values: InvoiceFormTypes.Preview) => {
    const loadFileContent = (response: AxiosResponse<any, any>) => {
      const htmlContent = response.data as unknown as string;
      setFileMeta(
        htmlContent
          ? [
              {
                id: 0,
                contentType: "html",
                numberOfPages: 1,
                data: htmlContent,
              },
            ]
          : undefined
      );
    };

    if ((status === undefined || status === WintSuperkollAPIModel.InvoiceStatus.NotSent) && invoicePut) {
      const invoicePost: WintSuperkollAPIModel.InvoicePreviewRequest = invoiceService.convertInvoicePutToPreviewRequest(
        { ...invoicePut, notes: values.notes },
        fromRecurring,
        recurringInvoiceVersion,
        recurringId
      );

      if (invoiceId) {
        invoicePost.serialNumber = serialNumber;
        invoicePost.oCRText = ocr;
      } else {
        invoicePost.serialNumber = undefined;
        invoicePost.oCR = undefined;
        invoicePost.oCRText = undefined;
      }
      invoiceService.generateInvoicePreview(invoicePost).then(loadFileContent);
    } else if (invoiceId) {
      if (isReminder) {
        invoiceService
          .getInvoiceReminderPDFPreview(invoiceId, {
            reminderDueDate: values.reminderDate,
            reminderCost: values.reminderCost,
            reminderMessage: values.notes,
          })
          .then(loadFileContent);
      } else {
        invoiceService.getInvoicePDFPreview(invoiceId, version).then(loadFileContent);
      }
    }
  }, InvoiceConstants.DebounceDelay);

  React.useEffect(() => {
    loadInvoiceTemplate(values);
  }, [values]);

  return (
    <Portal container={invoiceTemplateMount}>
      <FileViewerContainer meta={fileMeta} parentId={0} preventDownload />
    </Portal>
  );
};

export default InvoiceTemplatePreview;
